import { render, staticRenderFns } from "./UserSelector.vue?vue&type=template&id=35f79e03&scoped=true&"
import script from "./UserSelector.vue?vue&type=script&lang=ts&"
export * from "./UserSelector.vue?vue&type=script&lang=ts&"
import style0 from "./UserSelector.vue?vue&type=style&index=0&id=35f79e03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f79e03",
  null
  
)

export default component.exports